import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
  testId?: string;
}

const Card = (props: IconProps): JSX.Element => (
  <SvgIcon size={props?.size} testId={props?.testId}>
    <rect
      x="1"
      y="4"
      width="22"
      height="16"
      rx="1"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M2 10H23" stroke="currentColor" strokeWidth="4" />
  </SvgIcon>
);

export default Card;
